const Dashboard = {

    // PAGE HEADER
    "dashboard": "Main Dashboard",

    // TAGLINE
    "department_tagline": "Maintenance Insights",

    // CALENDAR
    "maintenance_calendar": "Maintenance Calendar",
    "status_legend": "Status Legend",

}

export default Dashboard;